module.exports = __webpack_public_path__ + "files/a314cd83d0e92e9971ee6586969ab96d.png";